export enum ParameterStatus {
    Success = "SUCCESS",
    Failed = "FAILED",
    Conflicted = "CONFLICTED",
    Unconfirmed = "UNCONFIRMED"
}
